import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, input, Input, Output, ViewChild } from '@angular/core';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';

@Component({
  selector: 'osp-overlay-panel',
  standalone: true,
  imports: [OverlayPanelModule, NgClass],
  templateUrl: './overlay-panel.component.html',
  styleUrl: './overlay-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverlayPanelComponent {
  @ViewChild('op') overlayPanel!: OverlayPanel;
  @Input() showHeader = true;
  @Input() showFooter = true;
  @Input() paddingless = true;
  @Input() wrapperClass = '';
  @Input() dismissable = true;
  @Input() appendTo: OverlayPanel['appendTo'];
  styleClass = input('');

  @Output() onShow = new EventEmitter<unknown>();
  @Output() onHide = new EventEmitter<unknown>();

  toggle(event: Event | PointerEvent): void {
    this.overlayPanel?.toggle(event);
  }

  hide(): void {
    this.overlayPanel?.hide();
  }

  show(event: Event | PointerEvent): void {
    this.overlayPanel?.show(event);
  }
}
